import { render, staticRenderFns } from "./UrlForm.vue?vue&type=template&id=550e8710&scoped=true&"
import script from "./UrlForm.vue?vue&type=script&lang=js&"
export * from "./UrlForm.vue?vue&type=script&lang=js&"
import style0 from "./UrlForm.vue?vue&type=style&index=0&id=550e8710&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550e8710",
  null
  
)

export default component.exports